module.exports = __webpack_public_path__ + "img/ES0138.58ebb0fc.svg";